/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ateliere_Connect_Status_Getting_File_ContextInputs */

const en_ateliere_connect_status_getting_file_context = /** @type {(inputs: Ateliere_Connect_Status_Getting_File_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Getting file context from Ateliere...`)
};

const fr_ateliere_connect_status_getting_file_context = /** @type {(inputs: Ateliere_Connect_Status_Getting_File_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Récupération du contexte de fichier depuis Ateliere...`)
};

const de_ateliere_connect_status_getting_file_context = /** @type {(inputs: Ateliere_Connect_Status_Getting_File_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dateikontext von Ateliere abrufen...`)
};

const it_ateliere_connect_status_getting_file_context = /** @type {(inputs: Ateliere_Connect_Status_Getting_File_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ottenere il contesto del file da Ateliere...`)
};

const ru_ateliere_connect_status_getting_file_context = /** @type {(inputs: Ateliere_Connect_Status_Getting_File_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получение контекста файла из Ateliere...`)
};

const es_ateliere_connect_status_getting_file_context = /** @type {(inputs: Ateliere_Connect_Status_Getting_File_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obteniendo el contexto del archivo de Ateliere...`)
};

const zh_cn2_ateliere_connect_status_getting_file_context = /** @type {(inputs: Ateliere_Connect_Status_Getting_File_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从 Atelier 获取文件上下文...`)
};

const ja_ateliere_connect_status_getting_file_context = /** @type {(inputs: Ateliere_Connect_Status_Getting_File_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ateliere からファイル コンテキストを取得しています...`)
};

const hi_ateliere_connect_status_getting_file_context = /** @type {(inputs: Ateliere_Connect_Status_Getting_File_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एटेलियर से फ़ाइल संदर्भ प्राप्त किया जा रहा है...`)
};

const pt_pt2_ateliere_connect_status_getting_file_context = /** @type {(inputs: Ateliere_Connect_Status_Getting_File_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtendo o contexto do arquivo do Ateliere...`)
};

/**
* | output |
* | --- |
* | "Getting file context from Ateliere..." |
*
* @param {Ateliere_Connect_Status_Getting_File_ContextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ateliere_connect_status_getting_file_context = /** @type {((inputs?: Ateliere_Connect_Status_Getting_File_ContextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ateliere_Connect_Status_Getting_File_ContextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ateliere_connect_status_getting_file_context(inputs)
	if (locale === "de") return de_ateliere_connect_status_getting_file_context(inputs)
	if (locale === "it") return it_ateliere_connect_status_getting_file_context(inputs)
	if (locale === "ru") return ru_ateliere_connect_status_getting_file_context(inputs)
	if (locale === "es") return es_ateliere_connect_status_getting_file_context(inputs)
	if (locale === "zh-CN") return zh_cn2_ateliere_connect_status_getting_file_context(inputs)
	if (locale === "ja") return ja_ateliere_connect_status_getting_file_context(inputs)
	if (locale === "hi") return hi_ateliere_connect_status_getting_file_context(inputs)
	if (locale === "pt-PT") return pt_pt2_ateliere_connect_status_getting_file_context(inputs)
	return en_ateliere_connect_status_getting_file_context(inputs)
});